<template>
  <v-content>
    <v-container 
      fluid 
      fill-height>
      <v-layout 
        align-center 
        justify-center>
        <v-flex 
          xs12 
          sm6
          md3>
          <v-card 
            id="grad"
            class="elevation-12 roundedcard">
            <div class="wevent_icon_wrapper_icons">
              <v-card-text class="text-xs-center">
                <img
                  
                  class="keep_calm_logo" 
                  src="@/assets/keep_calm.png" 
                  alt="Keep Calm">

                <p>404</p>
                <h1>NOTHING</h1>
                <h1>TO SEE</h1>
                <h2>HERE</h2>
                <h1>MOVE</h1>
                <h1>ALONG</h1>
              </v-card-text>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: bold;
  color: #e8e8e8;
}

#grad {
  background-image: linear-gradient(330deg, rgba(216,27,96,1), rgba(238,255,65,1));
}


img {
  width: 40%;
}

p {
  font-weight: bold;
  color: #e8e8e8;
  font-size: 3rem;
}

.keep_calm_logo {
  filter: invert(1) sepia(0.8) saturate(0) hue-rotate(0deg);
}
</style>
